import { Grid, IconButton } from '@mui/material';
import React from 'react';
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch } from 'src/hooks';
import { Header, TableComponent } from '../../../../pricing-simulator/types/generic-table.model';
import { toggleNoteDialog } from '../store/note-slice';
import { IProductComment } from '../../../../planner_v2/types/ppg-sku-drawer.model';
interface RowData {
 parent: {
   data: {
     scenario_id?: number;
     name?: string;
     note: IProductComment | null;
     [key: string]: any;
   };
 };
 [key: string]: any;
}
interface NoteCellProps {
 row: any;
 getValue: () => any;
}
const NoteCell = ({ row, getValue }: NoteCellProps) => {
 const appDispatch = useAppDispatch(); 
 const onEditNoteButtonClick = () => {
   const rowData = row.original;
   const noteData = rowData.note;
   const scenarioWithNote = {
     scenario_id: rowData.scenario_id,
     note_text: noteData?.comment_text || '',
     note_user: noteData?.comment_user_name || '',
     note_updated_at: noteData?.updated_at || '',
     note_pk_id: noteData?.pk_id || null,
   };
   appDispatch(
     toggleNoteDialog({
       visibility: true,
       scenario: scenarioWithNote,
     })
   );
 };
 const value = getValue();
 let displayText: string = 'Add Comment';
 if (value && typeof value === 'object' && 'comment_text' in value) {
   const commentText = (value as IProductComment).comment_text;
   if (commentText && commentText.trim() !== '') {
     displayText = commentText;
   }
 }
 return (
<>
<Grid container alignItems="left" flexDirection="column">
<Grid
         item
         xs={12}
         container
         alignItems="center"
         className="change-text"
>
<span
           onClick={onEditNoteButtonClick}
           onKeyDown={(e: { key: string }) => {
             if (e.key === 'Enter' || e.key === ' ') {
               onEditNoteButtonClick();
             }
           }}
           style={{
             maxWidth: '100px',
             overflow: 'hidden',
             textOverflow: 'ellipsis',
             whiteSpace: 'nowrap',
             display: 'inline-block',
             verticalAlign: 'middle',
             cursor: 'pointer',
             color: '#1976d2',
             textAlign: 'left',
           }}
           title={displayText}
>
           {displayText}
</span>
</Grid>
</Grid>
</>
 );
};
export default function GetNoteColumn(
 columnData: Header,
 componentType: TableComponent
) {
 const subHeader: ColumnDef<RowData> = {
   id:
     columnData.parent.parent_field !== ''
       ? columnData.parent.parent_field
       : columnData.parent.order.toString(),
   header: () => 'Note',
   accessorKey: 'note',
   meta: {
     className: 'note-column',
   },
   cell: ({ row, getValue }) => (
<NoteCell row={row} getValue={getValue} />
   ),
 };
 return subHeader;
}